
// Utility file for Google Analytics tracking

/**
 * Track a page view in Google Analytics
 * @param path The path to track (e.g., '/products')
 * @param title The page title
 */
export const trackPageView = (path: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-XTK2H6XBPY', {
      page_path: path,
      page_title: title || document.title
    });
    console.log(`Page view tracked: ${path}`);
  }
};
